import { Navigate } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import { useDoesUserHaveRole } from "../../../hooks/permissions";
import { UserRole } from "../../../utils/types/user";
import RestrictedUsersList from "../components/RestrictedUsersList/RestrictedUsersList";

export default function ClientChartRestrictionPage() {
    const canAccessClientChartRestrictions = useDoesUserHaveRole([
        UserRole.SUPER_ADMIN,
        UserRole.BILLER_ADMIN,
        UserRole.SUPPORT_GENERAL,
    ]);

    if (!canAccessClientChartRestrictions) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Navbar title="Client chart restrictions" />
            <div className="page">
                <RestrictedUsersList />
            </div>
        </>
    );
}
